/* YTB Scroll Reveal + Number Counter — zero-jank, IntersectionObserver-only */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.querySelectorAll('[data-reveal]').forEach(function (el) {
      el.classList.add('is-visible');
    });
    return;
  }

  /* ── Scroll reveal ── */
  var revealObserver = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        revealObserver.unobserve(entry.target);
      });
    },
    { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
  );

  function observeRevealElements() {
    document.querySelectorAll('[data-reveal]:not(.is-visible)').forEach(function (el) {
      revealObserver.observe(el);
    });
  }

  /* ── Number counter ── */
  function animateCount(el) {
    var target = parseFloat(el.getAttribute('data-count-to'));
    var suffix = el.getAttribute('data-count-suffix') || '';
    var prefix = el.getAttribute('data-count-prefix') || '';
    var duration = parseInt(el.getAttribute('data-count-duration') || '2000', 10);
    var decimals = (String(target).split('.')[1] || '').length;
    var start = 0;
    var startTime = null;

    function easeOutExpo(t) {
      return t === 1 ? 1 : 1 - Math.pow(2, -10 * t);
    }

    function step(timestamp) {
      if (!startTime) startTime = timestamp;
      var progress = Math.min((timestamp - startTime) / duration, 1);
      var easedProgress = easeOutExpo(progress);
      var current = start + (target - start) * easedProgress;
      el.textContent = prefix + current.toFixed(decimals) + suffix;
      if (progress < 1) {
        requestAnimationFrame(step);
      }
    }

    el.textContent = prefix + '0' + suffix;
    requestAnimationFrame(step);
  }

  var counterObserver = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        animateCount(entry.target);
        counterObserver.unobserve(entry.target);
      });
    },
    { threshold: 0.3 }
  );

  function observeCounters() {
    document.querySelectorAll('[data-count-to]:not(.counted)').forEach(function (el) {
      counterObserver.observe(el);
      el.classList.add('counted');
    });
  }

  /* ── Auto-tag sections for reveal — only top-level sections, not cards ── */
  function autoTagSections() {
    document.querySelectorAll('.shopify-section > div, .shopify-section > section').forEach(function (el) {
      if (el.hasAttribute('data-reveal') || el.closest('[data-reveal]')) return;
      if (el.closest('header') || el.closest('footer') || el.closest('#header-group')) return;
      if (el.getBoundingClientRect().top < window.innerHeight) return;
      el.setAttribute('data-reveal', 'fade-up');
    });
  }

  /* ── Init ── */
  function init() {
    autoTagSections();
    observeRevealElements();
    observeCounters();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Re-observe only in Shopify theme editor */
  if (Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function() {
      autoTagSections();
      observeRevealElements();
      observeCounters();
    });
  }
})();
